import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-discount-calculator',
  templateUrl: './discount-calculator.component.html',
  styleUrls: ['./discount-calculator.component.scss']
})
export class DiscountCalculatorComponent implements OnInit {

  constructor() { }

  startDate: Date;

  /**
   * 
   */
   vm$: Observable<IDiscountCalculatorViewModel>;

  ngOnInit(): void {
  }

}

/**
 * 
 */
 interface IDiscountCalculatorViewModel {
  
  workingText?: string;
  errorText?: string;
}

